module.exports = __webpack_public_path__ + "img/icon-pending-duration.8d6cf45c.png";